<script>
import appConfig from '@src/app.config'
import { ErrorWrapper } from '@utils/error-handler'
import { BOverlay } from 'bootstrap-vue'
import {
  blogListMethod,
  categoryListMethod,
  categoryComputed,
  siteListMethod,
  authComputed,
  userListMethod,
  departmentListMethod,
  departmentComputed,
  collegeListMethod,
  collegeComputed,
} from '@state/helpers'
import VueTagsInput from '@johmun/vue-tags-input'
import { Quill } from 'vue-quill-editor'
var Link = Quill.import('formats/link')
var builtInFunc = Link.sanitize
Link.sanitize = function customSanitizeLinkInput(linkValueInput) {
  var val = linkValueInput

  // do nothing, since this implies user's already using a custom protocol
  if (/^\w+:/.test(val));
  else if (!/^https?:/.test(val)) val = 'http://' + val

  return builtInFunc.call(this, val) // retain the built-in logic
}
export default {
  page: {
    title: 'Update Blog',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    'b-overlay': BOverlay,
    VueTagsInput,
  },
  props: {
    data: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  data() {
    return {
      autocompleteItems: [
        {
          text: 'Artificial Intelligence',
        },
        {
          text: 'Python',
        },
        {
          text: 'Javascript',
        },
        {
          text: 'Big Data',
        },
        {
          text: 'HTML',
        },
      ],
      title: '',
      tag: '',
      tags: [],
      blogError: null,
      blogSuccess: null,
      category: null,
      subcategory: null,
      isBlogError: false,
      isSuccess: false,
      isLoading: false,
      editorData: '',
      categoryName: '',
      image: '',
      imageNew: '',
      show: false,
      siteconfiglist: [],
      platformId: [],
      validTypeError: false,
      validSizeError: false,
      titleCharsLeft: '',
      classlist: [],
      collegeId: '',
      collegeClass: [],
      collegeClassPrev: [],
      departmentId: [],
      departmentlist: [],
      collegelist: [],
      categoryError: false,
    }
  },
  computed: {
    ...categoryComputed,
    ...authComputed,
    ...departmentComputed,
    ...collegeComputed,
    filteredItems() {
      return this.autocompleteItems.filter((i) => {
        return i.text.toLowerCase().indexOf(this.tag.toLowerCase()) !== -1
      })
    },
  },
  mounted() {
    this.getCategories()
    this.getListOfCollege()
    this.getDepartments()
    if (this.role !== 'admin') {
      this.platformId.push(this.profileData.platform_id)
    }
    if (this.role === 'administrator' || this.role === 'admin') {
      this.getColleges()
    } else {
      this.collegeId = this.profileData.college_id
    }
    if (this.role === 'hod') {
      // this.departmentId.push(this.profileData.department)
      this.getClasses()
    }
  },
  methods: {
    ...blogListMethod,
    ...categoryListMethod,
    ...siteListMethod,
    ...userListMethod,
    ...departmentListMethod,
    ...collegeListMethod,

    getCategories() {
      const filter = {
        page: this.$route.query.page ? this.$route.query.page : 1,
        limit: 100,
        sort: 'sort_order',
        order: '-1',
      }
      this.fetchCategoryList({ filter })
        .then((categories) => {
          var listitems = []
          categories.forEach((element) => {
            var ele = {}
            let i = 0
            for (i = 0; i < this.departmentId.length; i++) {
              if (this.departmentId[i] === element.department) {
                ele.text = element.name
                ele.value = element._id
                ele.college = element.college_id
                listitems.push(ele)
              }
            }
          })
          this.categoryList = listitems
        })
        .catch((_error) => {})
    },

    // get list of platform
    getListOfCollege() {
      this.fetchSiteList()
        .then((siteconfig) => {
          var listitems = []
          siteconfig.forEach((element) => {
            var ele = {}
            ele.text = element.site_name
            ele.value = element.platform_id
            listitems.push(ele)
          })
          this.siteconfiglist = listitems
        })
        .catch((_error) => {})
    },
    // save blog
    saveBlog() {
      if (this.imageNew !== '') {
        if (
          localStorage.getItem('width') === '500' &&
          localStorage.getItem('height') === '500'
        ) {
          this.validSizeError = false
        } else {
          this.validSizeError = true
        }
      }
      if (
        this.category !== this.data.category_id &&
        (this.subcategory === this.data.subcategory_id &&
          this.data.subcategory_id !== null)
      ) {
        this.categoryError = true
        this.isLoading = false
      } else {
        this.categoryError = false
      }
      if (!this.validTypeError && !this.validSizeError && !this.categoryError) {
        this.isLoading = true
        let blogData = {
          id: this.data._id,
          title: this.title,
          description: this.editorData,
          category_id: this.category,
          subcategory_id: this.subcategory,
          tags: this.filterTag(this.tags),
          status: false,
          platform_id: this.platformId,
          collegeClass: [this.collegeClass, this.collegeClassPrev],
          department: this.departmentId,
          college_id: this.collegeId,
        }
        if (this.imageNew !== '') {
          blogData.image = this.imageNew
        }
        this.updateBlog({ blogData })
          .then((data) => {
            this.isLoading = false
            this.isError = false
            this.blogSuccess = 'Blog Updated Successfully'
            this.isSuccess = true
            window.location.reload()
          })
          .catch((error) => {
            this.isLoading = false
            var getError = new ErrorWrapper(error)
            this.blogError = getError.message
            this.isBlogError = true
          })
      }
    },
    getMinDate() {
      const now = new Date()
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
      const minDate = new Date(today)
      minDate.setDate(now.getDate() + 2)
      return minDate
    },

    // trigger when select image in input
    uploadImage: function() {
      var file = document.querySelector('input[type=file]').files[0]
      let mimeType = document.querySelector('input[type=file]').files[0].type
      if (
        mimeType === 'image/png' ||
        mimeType === 'image/jpeg' ||
        mimeType === 'image/jpg'
      ) {
        this.validTypeError = false
        var reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = (evt) => {
          let img = new Image()
          img.onload = () => {
            localStorage.setItem('width', img.width)
            localStorage.setItem('height', img.height)
          }
          img.src = evt.target.result
          this.imageNew = reader.result
        }
      } else {
        this.validTypeError = true
      }
    },
    // trigger when select category
    selectCategory() {
      this.show = true
      // this.categoryName = this.getCategoryName()
      this.fetchSubCategoryList({ category: this.category }).then((sub) => {
        this.show = false
      })
    },

    // it will return catgeory name
    getCategoryName() {
      var cate = this.categoryList.filter((item) => {
        return item._id === this.category
      })
      return cate[0].name
    },

    // filter tag
    filterTag(tags) {
      var finalTags = []
      tags.forEach((element) => {
        finalTags.push(element.text)
      })

      return finalTags
    },
    getCount() {
      this.titleCharsLeft = 100 - this.title.length
      if (this.title.length >= 100) {
        this.titleCharsLeft = 0
      }
    },
    restrictChars(event) {
      if (event.charCode === 32 && !this.title.length) {
        event.preventDefault()
      } else {
        return true
      }
    },

    getData() {
      if (this.data.image) {
        this.getSignedImage(this.data.image).then((image) => {
          this.image = image
        })
      }
      this.title = this.data.title
      this.category = this.data.category_id
      this.selectCategory()
      if (this.data.subcategory_id !== null) {
        this.subcategory = this.data.subcategory_id
      }
      let i = 0
      for (i = 0; i < this.data.tags.length; i++) {
        this.tags.push({ text: this.data.tags[i] })
      }
      this.editorData = this.data.description
      for (let i = 0; i < this.data.platform_id.length; i++) {
        this.platformId.push(this.data.platform_id[i])
      }
      this.getColleges()
      this.collegeId = this.data.college_id
      this.getDepartments()
      for (i = 0; i < this.data.department.length; i++) {
        this.departmentId.push(this.data.department[i])
        this.getClasses()
      }
      for (i = 0; i < this.data.collegeClass.length; i++) {
        this.collegeClass.push(this.data.collegeClass[i])
        this.collegeClassPrev.push(this.data.collegeClass[i])
      }
    },
    resetModal() {
      this.title = this.data.title
      this.category = this.data.category_id
      if (this.data.subcategory_id !== null) {
        this.subcategory = this.data.subcategory_id
      }
      this.departmentId = []
      this.collegeId = ''
      this.collegeClass = []
      this.platformId = []
      this.tags = []
      this.isBlogError = false
      this.categoryError = false
    },
    getClasses() {
      this.collegeClass = []
      this.collegeClassPrev = []
      this.fetchClassList()
        .then((classes) => {
          var listitems = []
          classes.forEach((element) => {
            let i = 0
            for (i = 0; i < this.departmentId.length; i++) {
              if (this.departmentId[i] === element.department) {
                var ele = {}
                ele.text = element.name
                ele.value = element._id
                ele.college = element.college_id
                listitems.push(ele)
              }
            }
          })
          this.classlist = listitems
          if (this.classlist.length > 1) {
            this.classlist.unshift({
              value: 'All',
              text: 'All',
            })
          }
        })
        .catch((_error) => {})
    },
    getColleges() {
      this.collegeId = ''
      const filter = {
        page: this.$route.query.page ? this.$route.query.page : 1,
        limit: 100,
        sort: 'sort_order',
        order: '-1',
      }
      this.fetchCollegeList({ filter })
        .then((college) => {
          var listitems = []
          college.docs.forEach((element) => {
            let i = 0
            this.platformId = this.platformId.filter(
              (item, index, self) => self.indexOf(item) === index
            )
            for (i = 0; i < this.platformId.length; i++) {
              if (element.platform_id === this.platformId[i]) {
                var ele = {}
                ele.text = element.name
                ele.value = element._id
                listitems.push(ele)
              }
            }
          })
          this.collegelist = listitems
        })
        .catch((_error) => {})
    },
    getDepartments() {
      this.departmentId = []
      const filter = {
        page: this.$route.query.page ? this.$route.query.page : 1,
        limit: 100,
        sort: 'sort_order',
        order: '-1',
      }
      this.fetchDepartmentList({ filter })
        .then((dept) => {
          var listitems = []
          dept.docs.forEach((element) => {
            if (element.college_id === this.collegeId) {
              var ele = {}
              ele.text = element.name
              ele.value = element._id
              listitems.push(ele)
            }
          })
          this.departmentlist = listitems
        })
        .catch((_error) => {})
    },
  },
}
</script>

<template>
  <b-modal
    id="blog-update-modal"
    title="Update "
    :hide-footer="true"
    @shown="getData"
    @hidden="resetModal"
  >
    <b-overlay :show="show" :opacity="0.6" rounded="sm">
      <b-card>
        <b-alert
          v-model="isSuccess"
          variant="success"
          v-html="blogSuccess"
        ></b-alert>
        <b-form @submit.prevent="saveBlog">
          <b-form-group
            label="Blog Title(Max:100 characters)"
            label-for="input-1"
          >
            <b-form-input
              id="input-1"
              v-model="title"
              type="text"
              parsley-trigger="change"
              required
              placeholder="Enter Title"
              :maxlength="100"
              @keyup="getCount"
              @keypress="restrictChars($event)"
            ></b-form-input>
            <p v-if="titleCharsLeft !== ''"
              >Characters left : {{ titleCharsLeft }}</p
            >
          </b-form-group>

          <b-form-group label="Blog Category" label-for="input-2">
            <b-form-select
              v-model="category"
              parsley-trigger="change"
              required
              @change="selectCategory"
            >
              <b-select-option :value="null" disabled
                >Select Category</b-select-option
              >
              <b-select-option
                v-for="cate in categoryList"
                :key="`cate${cate._id}`"
                :value="cate._id"
                >{{ cate.name }}</b-select-option
              >
            </b-form-select>
          </b-form-group>
          <b-form-group label="Blog Sub category" label-for="input-2">
            <b-form-select v-model="subcategory" parsley-trigger="change">
              <b-select-option :value="null" disabled
                >Select SubCategory</b-select-option
              >
              <b-select-option
                v-for="cate in subCategoryList"
                :key="`cate${cate._id}`"
                :value="cate._id"
                >{{ cate.name }}</b-select-option
              >
            </b-form-select>
          </b-form-group>
          <p v-if="categoryError" style="color:red;"
            >Please select subcategory</p
          >
          <b-form-group label="Blog Tags" label-for="input-2">
            <VueTagsInput
              v-model="tag"
              input-id="tags-separators"
              placeholder="Enter Tag(s) and Press Enter.."
              :tags="tags"
              :autocomplete-items="filteredItems"
              @tags-changed="(newTags) => (tags = newTags)"
            />
          </b-form-group>

          <b-form-group label="Blog Description" label-for="input-2">
            <quill-editor v-model="editorData" output="html" />
          </b-form-group>
          <b style="color:#323a46;">Uploaded Image:</b><br /><br />
          <img
            :src="image"
            style="width:200px;height:150px;margin:auto;"
          /><br /><br />
          <b-form-group
            label="Blog Image(Dimension: 500*500)"
            label-for="input-2"
          >
            <b-form-file
              id="file"
              placeholder="Choose a file or drop it here..."
              drop-placeholder="Drop file here..."
              @change="uploadImage"
            ></b-form-file>
            <p v-if="validTypeError" class="showError">Not a valid file type</p>
            <p v-if="validSizeError" class="showError"
              >Image Dimensions should be 500*500</p
            >
          </b-form-group>
          <b-form-group
            v-if="role === 'administrator' || role === 'admin'"
            label="Select College*"
            label-for="input-1"
          >
            <b-form-select
              v-model="collegeId"
              :options="collegelist"
              @change="getDepartments"
            ></b-form-select>
          </b-form-group>
          <b-form-group
            v-if="role !== 'hod' && role !== 'teacher'"
            label="Department"
            label-for="input-1"
          >
            <b-form-select
              v-model="departmentId"
              :options="departmentlist"
              multiple
              @change="getClasses"
            ></b-form-select>
          </b-form-group>
          <b-form-group
            v-if="role !== 'teacher'"
            label="Class"
            label-for="input-1"
          >
            <b-form-select
              v-model="collegeClass"
              :options="classlist"
              multiple
            ></b-form-select>
          </b-form-group>
          <!-- <b-form-group v-if="role === 'admin'" label="Select Platform">
            <b-form-select
              v-model="platformId"
              :options="siteconfiglist"
              multiple
            ></b-form-select>
          </b-form-group> -->
          <b-alert
            v-model="isBlogError"
            variant="danger"
            v-html="blogError"
          ></b-alert>
          <b-form-group id="button-group" class="mt-4">
            <b-button v-if="!isLoading" type="submit" variant="primary"
              >Save</b-button
            >
            <b-button
              v-else
              type="submit"
              variant="primary"
              class="btn-block"
              disabled
            >
              <b-spinner small></b-spinner>Loading...
            </b-button>
          </b-form-group>
        </b-form>
      </b-card>
    </b-overlay>
  </b-modal>
</template>
<style>
.vue-tags-input {
  max-width: 100% !important;
}
.ti-new-tag-input-wrapper input {
  font-family: 'Roboto', sans-serif;
  font-size: 0.9rem;
  font-weight: 400;
}
.ti-tag::before {
  display: none;
}
[class^='ti-'],
[class*=' ti-'] {
  /* font-family: inherit; */
  font-size: inherit !important;
  font-weight: inherit !important;
}
</style>
